import { render, staticRenderFns } from "./RulesetViewerTrigger.vue?vue&type=template&id=c1507116&scoped=true&"
import script from "./RulesetViewerTrigger.vue?vue&type=script&lang=js&"
export * from "./RulesetViewerTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1507116",
  null
  
)

export default component.exports